import { loadable } from "components/SpruceLoader";

export const VariantHistory = loadable(() => import("./variantHistory/index"));
